export default __webpack_public_path__ + "static/media/PGOAX82718-0242.ad4688f0.jpg";